const FrontEndLogo = ({ className, ...props }) => (
	<svg
		width={31}
		height={30}
		viewBox="0 0 31 30"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
		className={className}
	>
		<circle
			cx={15.5}
			cy={15}
			r={14}
			stroke="var(--primary-icon-foreground)"
			strokeWidth={1.3125}
		/>
		<g clipPath="url(#clip0_1985_9743)">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.4981 10.8553C16.7698 10.8553 17.8007 9.82434 17.8007 8.55265C17.8007 7.28093 16.7698 6.25 15.4981 6.25C14.2264 6.25 13.1955 7.28093 13.1955 8.55262C13.1955 9.82434 14.2264 10.8553 15.4981 10.8553ZM17.5374 23.1706L15.9174 19.6065C15.7538 19.2466 15.2425 19.2466 15.0789 19.6065L13.4589 23.1706C13.2985 23.5235 12.9467 23.75 12.5591 23.75C11.9353 23.75 11.4675 23.1794 11.5899 22.5678L12.9977 15.5284C13.1155 14.9392 12.8391 14.3415 12.3139 14.0497L9.54577 12.5119C9.24024 12.3421 9.05078 12.0201 9.05078 11.6706C9.05078 11.0312 9.66277 10.5696 10.2775 10.7452L14.355 11.9102C15.1021 12.1237 15.8941 12.1237 16.6413 11.9102L20.7187 10.7452C21.3335 10.5696 21.9455 11.0312 21.9455 11.6706C21.9455 12.0201 21.756 12.3421 21.4505 12.5119L18.6823 14.0497C18.1571 14.3415 17.8807 14.9392 17.9985 15.5284L19.4064 22.5678C19.5287 23.1794 19.061 23.75 18.4372 23.75C18.0496 23.75 17.6978 23.5235 17.5374 23.1706Z"
				fill="var(--primary-icon-foreground)"
			/>
		</g>
		<defs>
			<clipPath id="clip0_1985_9743">
				<rect
					width={17.5}
					height={17.5}
					fill="var(--primary-icon-foreground)"
					transform="translate(6.75 6.25)"
				/>
			</clipPath>
		</defs>
	</svg>
);
export default FrontEndLogo;
